import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./CrmEventFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";

import CrmFormEventStepOne from "../CrmFormEventStep/CrmFormEventStepOne";

const CrmEventForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        eventType: _initialValues?.eventType
          ? { value: _initialValues?.eventType }
          : null,
        nextEventType: _initialValues?.nextEventType
          ? { value: _initialValues?.nextEventType }
          : null,
        offerStatus: _initialValues?.offerStatus
          ? { value: _initialValues?.offerStatus }
          : null,
        eventStatus: _initialValues?.eventStatus?.uuid
          ? { value: _initialValues?.eventStatus?.uuid }
          : null,
        representativeDecisionType: _initialValues?.representativeDecisionType
          ? { value: _initialValues?.representativeDecisionType }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <>
            <form
              id={props.formName}
              onSubmit={formProps.handleSubmit}
              className="CrmForm"
            >
              <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={step}
                onChangeIndex={(index) => setStep(index)}
              >
                <CrmFormEventStepOne {...formProps} {...props} />
              </SwipeableViews>
            </form>
          </>
        );
      }}
    </Form>
  );
};

export default CrmEventForm;
